import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { PasswordGate } from "./pages/PasswordGate";
import { Navbar } from "./components/Navbar";
import { Home } from "./pages/Home";
import { Story } from "./pages/Story";
import { Schedule } from "./pages/Schedule";
import { Transport } from "./pages/Transport";
import { FAQ } from "./pages/FAQ";
import { Travel } from "./pages/Travel";
import { RSVP } from "./pages/RSVP";
import { Sketches } from "./pages/Sketches";

export function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    fetch("/api/auth")
      .then((res) => res.json())
      .then((data) => setAuthenticated(data.ok))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (loading) return null;

  if (!authenticated) {
    return <PasswordGate onAuthenticated={() => setAuthenticated(true)} />;
  }

  return (
    <div className="relative">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/story" element={<Story />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/travel" element={<Travel />} />
        <Route path="/transport" element={<Transport />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/rsvp" element={<RSVP />} />
        <Route path="/sketches" element={<Sketches />} />
      </Routes>
    </div>
  );
}

export default App;
